@if (this.authService.checkLoginAuthentication()) {
<app-nav-bar></app-nav-bar>
}

<router-outlet />
